<section class="content tab-section d-flex">
    <div class="content-block flex-grow-1">
        <div class="tab-content flex-grow-1 "></div>
    </div>
</section>